module.exports = {
  "country": "HU",
  "artist": "Freddie",
  "song": "Pioneer",
  "year": "2016",
  "place": "19",
  "spotify": "6I3hrpXe8aT3e8uaCOO1ym"
};